import { useTextes } from '@common/config';
import { useSessionContext } from '@common/hooks';
import { useSelectedCampagne} from '@common/hooks/campagne';
import { useOfaDetails } from '@common/hooks/organisme';
import { CampagneStatut, IAM_ROLES } from '@common/services';
import { getModalById, OfaMessageBanner } from '@common/ui';
import { MyOfaEstablishmentsPanel } from '@common/ui/etablissement';
import { EditOfaAdminsModal, EditOfaRlModal } from '@common/ui/modal/organisme';
import { OfaFilesPanel, OfaInfoPanel, OfaUserPanel, OfaUsersPanel } from '@common/ui/panel/organisme';
import React, { useState } from 'react';
import { OfaCampagneSelect } from '../../components/OfaCampagneSelect';
import { MyOfaHeader } from './components/MyOfaHeader';

const editRLInfoModal = getModalById('edit-rl-info-modal');
const editAdminInfoModal = getModalById('edit-admin-info-modal');

export const MyOfa = () => {
  const t = useTextes('Commun', 'Campagne');

  const { organismeId, accessHistory } = useSessionContext();
  const { selectedCampagne, setSelectedCampagneYear } = useSelectedCampagne();

  const [selectedOrganismeId, setSelectedOrganismeId] = useState<number>(organismeId);

  const { organisme, usersMap, isLoading } = useOfaDetails({ id: selectedOrganismeId });

  const handleYearChange = (year: number) => {
    setSelectedCampagneYear(year);
    const access = accessHistory.find((a) => a.campagneAnnee === year);
    if (access) setSelectedOrganismeId(access.organismeId);
  };

  if (isLoading || !selectedCampagne) return null;
  const isCampagneArchived = (selectedCampagne.statut === CampagneStatut.ARCHIVEE);

  const iamUtilisateurs = organisme.utilisateurs.filter(u => IAM_ROLES.includes(u.role));

  return (
    <div className={'flex flex-col gap-6'}>

      <MyOfaHeader organisme={organisme} />

      <OfaCampagneSelect onYearChange={handleYearChange} />

      {isCampagneArchived && (
        <OfaMessageBanner title={t['CAMPAGNE_TERMINEE_MSG1']}
                          subtitle={organisme.depotProlonge
                            ? t['CAMPAGNE_TERMINEE_MSG2']
                            : t['CAMPAGNE_TERMINEE_MSG3']} />
      )}

      <div className={'separator'} />

      <OfaInfoPanel organisme={organisme} />

      <div className={'grid grid-cols-3 justify-stretch gap-5'}>

        <div className={'col-span-2 flex flex-col gap-4'}>

          <OfaUserPanel title={'Représentant légal'}
                        user={usersMap.REPRESENTANT}
                        extraUser={{
                          user: usersMap.DELEGATAIRE,
                          openLabel: '+ Afficher les informations du délégataire',
                          closeLabel: '- Cacher les informations du délégataire',
                        }}
                        onEdit={() => editRLInfoModal.open()} />

          <OfaUserPanel title={'Administrateur'}
                        user={usersMap.ADMIN_1}
                        dateHabilitation={organisme.dateHabilitation}
                        extraUser={{
                          user: usersMap.ADMIN_2,
                          openLabel: '+ Afficher les informations du 2e administrateur',
                          closeLabel: '- Cacher les informations du 2e administrateur',
                        }}
                        displayJobAndDates
                        onEdit={() => editAdminInfoModal.open()} />
        </div>

        <OfaFilesPanel organismeId={organisme.id} organismeStatut={organisme.statut} />
      </div>

      <MyOfaEstablishmentsPanel organisme={organisme} />

      <OfaUsersPanel utilisateurs={iamUtilisateurs}
                     organismeId={organisme.id}
                     isFc={false} />

      <EditOfaRlModal dsfrModal={editRLInfoModal}
                      organismeId={organisme.id}
                      organismeStatut={organisme.statut}
                      representant={usersMap.REPRESENTANT}
                      delegataire={usersMap.DELEGATAIRE} />

      <EditOfaAdminsModal dsfrModal={editAdminInfoModal}
                          organisme={organisme}
                          admin1={usersMap.ADMIN_1}
                          admin2={usersMap.ADMIN_2} />
    </div>
  );
};